<div class="w-100 bg-secondary-subtle text-secondary text-center rounded-4 py-4 px-3">
  <span class="fw-semibold">{{ text }}</span>
</div>
